// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[master]7.2-rc-11836(8598c0735d)-C30/09/2025-09:37:54-B30/09/2025-09:43:12' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[master]7.2-rc-11836(8598c0735d)-C30/09/2025-09:37:54-B30/09/2025-09:43:12",
  branch: "master",
  latestTag: "7.2-rc",
  revCount: "11836",
  shortHash: "8598c0735d",
  longHash: "8598c0735de1a90db6acff8203c54064be0d9551",
  dateCommit: "30/09/2025-09:37:54",
  dateBuild: "30/09/2025-09:43:12",
  buildType: "Ansible",
  } ;
